/**
 * 認證服務
 * 處理用戶認證、登入和登出等相關操作
 */

import { User } from "../models";
import { COOKIE_KEYS } from "@/domain/constants/cookies";
import { api, endpoints } from "@/infrastructure/api";

/**
 * 登入請求介面
 */
// interface LoginRequest {
//   email: string;
//   password: string;
// }

/**
 * 認證服務對象
 */
export const authService = {
  /**
   * 使用 Google 登入
   * @param token Google 認證令牌
   * @returns 登入成功完成後的用戶資訊和令牌
   */
  async loginWithGoogle(token: string): Promise<{ token: string }> {
    const response = await api.post<{
      access_token: string;
      token_type: string;
      expires_in: number;
    }>(endpoints.auth.googleLogin, { id_token: token });

    localStorage.setItem(COOKIE_KEYS.AUTH_TOKEN, response.access_token);

    return {
      token: response.access_token,
    };
  },

  async oauthWithGoogle(googleResponse: object): Promise<{ token: string }> {
    const response = await api.post<{
      access_token: string;
      token_type: string;
      expires_in: number;
    }>(endpoints.auth.googleOauth, googleResponse);

    localStorage.setItem(COOKIE_KEYS.AUTH_TOKEN, response.access_token);

    return {
      token: response.access_token,
    };
  },

  /**
   * 用戶登出
   */
  async logout(): Promise<void> {
    try {
      await api.post<void>(endpoints.auth.logout, {});
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      localStorage.removeItem(COOKIE_KEYS.AUTH_TOKEN);
    }
  },

  /**
   * 獲取當前登入用戶資訊
   * @returns 用戶資訊
   */
  async getCurrentUser(): Promise<User> {
    return await api.get<User>(endpoints.users.me);
  },

  /**
   * 檢查用戶是否已經登入
   * @returns 是否已登入
   */
  isAuthenticated(): boolean {
    return !!localStorage.getItem(COOKIE_KEYS.AUTH_TOKEN);
  },
};
